import Math from './util.math'

/**
 * 数值四舍五入
 * @param {*} x 需要转换的数值
 * @param {*} y 保留位数，默认保留2位
 * @returns
 */
export function round(x, y = 2) {
  if (!x) return 0
  const fixed = Math.pow(10, y)
  return divide(Math.round(multiply(x, fixed)), fixed)
}

/**
 * 数值向下舍入
 * @param {*} x 需要转换的数值
 * @param {*} y 保留位数，默认保留2位
 * @returns
 */
export function roundDown(x, y = 2) {
  if (!x) return 0
  const fixed = Math.pow(10, y)
  return divide(Math.floor(multiply(x, fixed)), fixed)
}

/**
 * 除法运算
 * @param {*} x 被除数
 * @param {*} y 除数
 * @returns
 */
export function divide(x, y) {
  if (!y) return 0
  return Math.number(Math.divide(Math.bignumber(x), Math.bignumber(y)))
}

/**
 * 乘法运算
 * @param {*} x 因数
 * @param {*} y 因数
 * @returns
 */
export function multiply(x, y) {
  if (!x || !y) return 0
  return Math.number(Math.multiply(Math.bignumber(x), Math.bignumber(y)))
}

/**
 * 减法运算
 * @param {*} x 因数
 * @param {*} y 因数
 * @returns
 */
export function subtract(x, y) {
  x = x || 0
  y = y || 0
  return Math.number(Math.subtract(Math.bignumber(x), Math.bignumber(y)))
}

/**
 * 加法运算
 * @param {*} x 加数
 * @param {*} y 加数
 * @returns
 */
export function add(x, y) {
  x = x || 0
  y = y || 0
  return Math.number(Math.add(Math.bignumber(x), Math.bignumber(y)))
}

/**
 * 除法运算，向下取整
 * @param {*} x 被除数
 * @param {*} y 除数
 * @param {*} l 保留位数，默认保留4位
 * @returns
 */
export function divideDown(x, y, l = 4) {
  if (!y) return 0
  return roundDown(divide(x, y), l)
}

/**
 * 乘法运算，向下取整
 * @param {*} x 因数
 * @param {*} y 因数
 * @param {*} l 保留位数，默认保留4位
 * @returns
 */
export function multiplyDown(x, y, l = 4) {
  if (!x || !y) return 0
  return roundDown(multiply(x, y), l)
}

/**
 * 减法运算，向下取整
 * @param {*} x 因数
 * @param {*} y 因数
 * @param {*} l 保留位数，默认保留4位
 * @returns
 */
export function subtractDown(x, y, l = 4) {
  return roundDown(subtract(x, y), l)
}

/**
 * 加法运算，向下取整
 * @param {*} x 加数
 * @param {*} y 加数
 * @param {*} l 保留位数，默认保留4位
 * @returns
 */
export function addDown(x, y, l = 4) {
  return roundDown(add(x, y), l)
}

/**
 * 除法运算，四舍五入
 * @param {*} x 被除数
 * @param {*} y 除数
 * @param {*} l 保留位数，默认保留4位
 * @returns
 */
export function divideRound(x, y, l = 4) {
  if (!y) return 0
  return round(divide(x, y), l)
}

/**
 * 乘法运算，四舍五入
 * @param {*} x 因数
 * @param {*} y 因数
 * @param {*} l 保留位数，默认保留4位
 * @returns
 */
export function multiplyRound(x, y, l = 4) {
  if (!x || !y) return 0
  return round(multiply(x, y), l)
}

/**
 * 减法运算，四舍五入
 * @param {*} x 因数
 * @param {*} y 因数
 * @param {*} l 保留位数，默认保留4位
 * @returns
 */
export function subtractRound(x, y, l = 4) {
  return round(subtract(x, y), l)
}

/**
 * 加法运算，四舍五入
 * @param {*} x 加数
 * @param {*} y 加数
 * @param {*} l 保留位数，默认保留4位
 * @returns
 */
export function addRound(x, y, l = 4) {
  return round(add(x, y), l)
}
